import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSlidesOptions} from '@Components/contextual-menu/components/contextual-menu-slides-options';
import {useSingleActivePosterItem} from '@Hooks/poster-editor/useSingleActivePosterItem';

export function SlideshowSlidesOption(): ReactElement<any> {
  const activeItem = useSingleActivePosterItem();

  if (!activeItem) {
    throw new Error('Active item does not exist in SlideshowSlidesOption');
  }

  if (!activeItem.isSlideshow()) {
    throw new Error(`Expected active item to be of type slideshow, instead got ${activeItem.gitype}`);
  }

  const onChangeIntroDelay = (updatedValue: number): void => {
    activeItem.updateOnPageStartTime(updatedValue, false);
  };

  const onChangeIntroDelayEnded = (updatedValue: number): void => {
    const getAllowedIntroDelayValue = activeItem.getMaxPossibleIntroDelayFromValue(updatedValue);
    activeItem.updateOnPageStartTime(getAllowedIntroDelayValue);
  };

  return (
    <ContextualMenuSlidesOptions
      id="slideshow-slides-option"
      introDelay={activeItem.onPageStartTime}
      onChangeIntroDelayEnded={onChangeIntroDelayEnded}
      onChangeIntroDelay={onChangeIntroDelay}
      numberOfItems={activeItem.slides.getNumberOfSlides()}
    />
  );
}
